__turbopack_context__.v({
  "button": "GlobalLoginGate-module__vzM4oq__button",
  "card": "GlobalLoginGate-module__vzM4oq__card",
  "error": "GlobalLoginGate-module__vzM4oq__error",
  "form": "GlobalLoginGate-module__vzM4oq__form",
  "icon": "GlobalLoginGate-module__vzM4oq__icon",
  "iconWrap": "GlobalLoginGate-module__vzM4oq__iconWrap",
  "input": "GlobalLoginGate-module__vzM4oq__input",
  "label": "GlobalLoginGate-module__vzM4oq__label",
  "message": "GlobalLoginGate-module__vzM4oq__message",
  "root": "GlobalLoginGate-module__vzM4oq__root",
  "title": "GlobalLoginGate-module__vzM4oq__title",
});
